import React from 'react'
import { useParams } from 'react-router-dom'
import { AppBar, Toolbar, useTheme, makeStyles } from '@material-ui/core'

import { styles } from './helpLayout.styles'
import Page from '../../../components/page/page'
import { HelpContent } from '../../../components/layout/components/sidePanel/components/help/helpContent'

export interface HelpLayoutProps {}

export const HelpLayout: React.FC<HelpLayoutProps> = props => {
  const currentTheme = useTheme()
  const useStyles = makeStyles(styles(currentTheme))
  const classes = useStyles()

  let { wikiPath } = useParams() as any
  const decodedWikiPath = decodeURIComponent(wikiPath)

  return (
    <Page fullWidth={false}>
      <div className={classes.root}>
        <AppBar position="fixed" className={classes.appBar} elevation={0}>
          <Toolbar variant="dense">
            <div className={classes.logo} />
          </Toolbar>
        </AppBar>
        <HelpContent contentPath={decodedWikiPath} />
      </div>
    </Page>
  )
}
